// import Alpine from 'alpinejs';
// import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';

import AccountManagementUI from './components/account-management-ui.js';
import ConfirmationBlockUI from './components/confirmation-block-ui.js';
import DownloadPageUI from './components/download-page-ui.js';
import DropDown from './components/drop-down.js';
import EnvoyPoem from './components/envoy-poem.js';
import Iconography from './components/iconography.js';
import KeyupAllowNumbersFilter from './components/keyup-allow-numeric-filter.js';
import LegacyHWID from './components/legacy-hwid.js';
import MastheadVideo from './components/masthead-video.js';
import Modal from './components/modal.js';
import Navigation from './components/navigation.js';
import OneTrustLocal from './components/one-trust-local.js';
import Recaptcha from './components/recaptcha.js';
import SearchFieldValidation from './components/search-field-validation.js';
import SignupForm from './components/signup-form.js';
import StandaloneVideo from './components/standalone-video.js';
import TabbedUI from './components/tabbed-ui.js';
import YouTubePlaylist from './components/youtube-playlist.js';

import { anchorSmoothScroll } from "./methods/ui-anchor-smooth-scroll.js";
import { dataLayerEvents, autowireAnalytics } from "./methods/data-layer-event-handler.js";
import { elementWrapper } from "./methods/ui-element-wrapper.js";
import { replaceScrollbar } from "./methods/ui-scroll-replacement.js";
import { loadScript} from "./methods/script-loader.js";
import { togglePassword } from "./methods/event-handler-toggle-password.js";
import { watchViewport } from "./methods/polyfill-app-viewport";


window.Alpine = Alpine;
//window.Livewire = window.Livewire || {};
window.app = window.app || {};

/**
 * `.env` variables that have been exposed via Mix.js are available in `process.env`
**/

window.addEventListener('alpine:init', (event) => {
    // console.log('page is fully loaded');
    Alpine.data( "ConfirmationBlockUI", ConfirmationBlockUI );
    Alpine.data( "DownloadPageUI", DownloadPageUI );
    Alpine.data( "DropDown", DropDown );
    Alpine.data( 'EnvoyPoem', EnvoyPoem );
    Alpine.data( 'Iconography', Iconography );
    Alpine.data( 'KeyupAllowNumbersFilter', KeyupAllowNumbersFilter );
    Alpine.data( 'MastheadVideo', ( object ) => MastheadVideo( object ) );
    Alpine.data( 'LegacyHWID', LegacyHWID );
    Alpine.data( 'Modal', Modal );
    Alpine.data( 'Navigation', Navigation );
    Alpine.data( 'Recaptcha', ( action ) => Recaptcha( action ) );
    Alpine.data( 'SearchFieldValidation', SearchFieldValidation );
    Alpine.data( 'SignupForm', SignupForm );
    Alpine.data( 'StandaloneVideo', StandaloneVideo );
    Alpine.data( 'TabbedUI', TabbedUI );
    Alpine.data( 'YouTubePlaylist', YouTubePlaylist );
    Alpine.data( 'AccountManagementUI', AccountManagementUI );

    Alpine.data( 'OneTrustLocal', OneTrustLocal );
    //Alpine.start();

    // maintain an App Height for use in CSS (that does not rely on the `vh` because iOS)
    watchViewport();

    // set analytics `window.dataLayer` event handlers
    dataLayerEvents();
    autowireAnalytics();

    // password input toggle (without Alpine; because Livewire)
    document.addEventListener( "click", togglePassword, false );

    // wrap (CMS content) tables by selector string
    [
        '[data-slug=cookie-list] #cookie-list .layout .cookie-list-policy table',
        '[data-slug="news-detail"] #news-details .content > table'
    ].forEach( selector => {
        elementWrapper( selector, "table-wrapper" );
    } );

    // wrap (CMS Page content) images by selector string
    [
        '#cms-page .content img'
    ].forEach( selector => {
        elementWrapper( selector, "image-wrapper" );
    } );

    // wrap (CMS content) YouTube Embeds by selector string
    [
        '[data-slug="news-detail"] #news-details .content iframe[ src*="youtube.com"]',
        '[data-slug="news-detail"] #news-details .content iframe[ src*="youtu.be"]'
    ].forEach( selector => {
        elementWrapper( selector, "youtube-wrapper" );
    } );

    // Sitewide smooth scrolling
    [ '[ data-scroll-trigger ]' ].forEach( selector => {
        anchorSmoothScroll( selector );
    } );

    // Targeted scroll replacement
    [ '[ data-scroll-replacement ]' ].forEach( selector => {
        replaceScrollbar( selector );
    } );

    if ( !!window.Livewire ) {
        window.Livewire.on('updateDisplayName', value => {
            let el_target = document.querySelector( '#user-profile > span' );
            // console.log('Event received with value:', value);

            if( !!el_target ) {
                el_target.textContent = value;
            }
        });
    }

});


